import { isIOS } from './is-ios'
import { isSafari } from './is-safari'
import { isInStandalone } from './is-stand-alone'

export const canDisplayInstallOnIos = () => isIOS() && isSafari() && !isInStandalone()
